import { IBrand } from "@/models/IBrand";
import { BaseRepository } from "@/repositories/BaseRepository";

class BrandRepository extends BaseRepository<IBrand> {
    constructor() {
        super("/brands");
    }
}

const brandRepository = new BrandRepository();

export { BrandRepository, brandRepository };
